import { Valence } from '@upright/common/model/types';
import { InfoBoxTitleRow } from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/info-box-title-row';
import {
  commonInfoBoxBorder,
  commonInfoBoxPadding,
} from '@upright/ui/common/upright/core/impact-lens-profile/common/components/info-boxes/styles';
import { PropsWithChildren, CSSProperties } from 'react';
import styled from 'styled-components';
import { valenceToSide } from '../../../../../impact-lens-profile/common/utils';
import { useCarouselLayout } from '../../../../../impact-lens-profile/context';

interface Props {
  valence: Valence.NEGATIVE | Valence.POSITIVE;
  entityName: string | undefined;
}

export function KeyTakeawayBoxFrame(props: PropsWithChildren<Props>) {
  const layout = useCarouselLayout();
  const ba = layout.boxesArea(valenceToSide(props.valence));
  const style: CSSProperties = {
    width: ba.width,
    left: ba.x1,
    top: ba.y1,
    height: ba.height,
    boxSizing: 'border-box',
  };

  return (
    <Root style={style}>
      <Inner>
        <Wrap>
          <InfoBoxTitleRow>
            <Title>{getTitle(props.valence)}</Title>
          </InfoBoxTitleRow>
          <Text>{props.children}</Text>
        </Wrap>
      </Inner>
    </Root>
  );
}

const Root = styled.div`
  position: absolute;
  top: 50%;
  bottom: 50%;
`;

const Inner = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;

const Wrap = styled.div`
  ${commonInfoBoxBorder};
  background-color: white;
  width: 100%;
`;

const Title = styled.div``;

const Text = styled.div`
  ${commonInfoBoxPadding};
  font-size: 12px;
  font-weight: 400;
  text-align: left;
  line-height: 128.8%;
`;

function getTitle(valence: Valence) {
  switch (valence) {
    case Valence.POSITIVE:
      return 'Top positive impacts';
    case Valence.NEGATIVE:
      return 'Top negative impacts';
    default:
      throw Error(`Invalid valence: ${valence}`);
  }
}
